export default "__VITE_ASSET__DLrCD2jW__"